import {
  SubContent,
  SubContent1,
  SubContent10,
  SubContent25,
  SubContent27,
  SubContent28,
  SubContent29,
  SubContent3,
  SubContent30,
  SubContent31,
  SubContent4,
  SubContent5,
  SubContent6,
  SubContent7,
  SubContent8,
  SubContent9
} from '@/components/qrender/types'

function _index2Abc(number) {
  return String.fromCharCode(65 + number)
}

function index2Abc(number) {
  if (number === undefined || number === null || number === '') return ''
  let num = +html2Text(number)
  return _index2Abc(num)
}

function html2Text(html: string) {
  let dom = document.createElement('div')
  dom.innerHTML = html
  return dom.innerText
}

// @deprecated
function inlineOption(options: string[]) {
  const len = options
    .map(html2Text)
    .map((item) => item.length + 1)
    .reduce((acc, b) => acc + b)
  return len < 50
}

function renderFormula($el: any) {
  const MathJax = (window as any).MathJax
  MathJax.Hub.Queue(['Typeset', MathJax.Hub])
}

function kpsDisplay(knowledge_points: string[]) {
  return (knowledge_points || []).join('；')
}

// tslint:disable-next-line
function _answersDisplay(subcontent: SubContent): string {
  if (subcontent.base_question_type == 1) {
    let sc = subcontent as SubContent1
    return index2Abc(sc.answers)
  } else if (subcontent.base_question_type == 3) {
    let sc = subcontent as SubContent3
    return (sc.answers || []).map(index2Abc).join('')
  } else if ([4, 30].includes(subcontent.base_question_type)) {
    let sc = subcontent as SubContent4 | SubContent30
    return (sc.answers || []).map((item) => item.join(' 或 ')).join('，')
  } else if (subcontent.base_question_type == 5) {
    let sc = subcontent as SubContent5
    if (sc.answers === undefined || sc.answers === null) return ''
    return sc.answers ? '正确' : '错误'
  } else if (subcontent.base_question_type == 6) {
    let sc = subcontent as SubContent6
    return sc.answers
  } else if ([7, 27].includes(subcontent.base_question_type)) {
    let sc = subcontent as SubContent7 | SubContent27
    return (sc.answers || []).map((item) => item.map(index2Abc).join(' —— ')).join('，')
  } else if ([8, 28].includes(subcontent.base_question_type)) {
    let sc = subcontent as SubContent8 | SubContent28
    return (sc.answers || [])
      .map((item) => item.classification + ': ' + (item.answers || []).map(index2Abc).join(''))
      .join('，')
  } else if (subcontent.base_question_type == 9) {
    let sc = subcontent as SubContent9
    return (sc.answers || []).map(index2Abc).join(' ')
  } else if (subcontent.base_question_type == 10) {
    let sc = subcontent as SubContent10
    return (sc.answers || []).map(index2Abc).join(' ')
  } else if ([25, 31].includes(subcontent.base_question_type)) {
    let sc = subcontent as SubContent25 | SubContent31
    return (sc.answers || []).join(' 或 ')
  } else if (subcontent.base_question_type == 29) {
    let sc = subcontent as SubContent29
    return (sc.answers || []).join('，')
  } else {
    return (subcontent as any).answers // 6, 16 以及其他
  }
}

function answersDisplay(subcontent: SubContent): string {
  return html2Text(_answersDisplay(subcontent))
}

// 替换'<latex>$$ aaa+bbb=ccc $$ </latex>' => '$$ $$'
// 替换'<latex>$ $</latex>' => '$ $'
// 替换'<latex>\(\)</latex>' => '\(\)'
// 替换'<latex>\[\]</latex>' => '\[\]'
// 替换'<latex></latex>' => '\(\)'
function _handleSplit(str) {
  return str
    .replace(/<\s*latex\s*>\s*\$\$/g, '$$$$')
    .replace(/\$\$\s*<\/latex>/g, '$$$$')
    .replace(/<\s*latex\s*>\s*\$/g, '$$')
    .replace(/\$\s*<\/latex>/g, '$$')
    .replace(/<\s*latex\s*>\s*\\\(/g, '\\(')
    .replace(/\\\)\s*<\/latex>/g, '\\)')
    .replace(/<\s*latex\s*>\s*\\\[/g, '\\[')
    .replace(/\\\]\s*<\/latex>/g, '\\]')
    .replace(/<\s*latex\s*>/g, '\\(')
    .replace(/<\/latex>/g, '\\)')
}

// plan jsobj: null,undefined, boolean, number, string, array(也是object), object
function transform(obj) {
  if (!obj || ['boolean', 'number'].includes(typeof obj)) return obj
  else if (typeof obj == 'string') return _handleSplit(obj)
  else if (Array.isArray(obj)) {
    return obj.map(transform)
  } else {
    let ret = {}
    for (let key of Object.keys(obj)) {
      ret[key] = transform(obj[key])
    }
    return ret
  }
}

function index2Roma(number: number) {
  const map = {
    1: 'i',
    2: 'ii',
    3: 'iii',
    4: 'iv',
    5: 'v',
    6: 'vi',
    7: 'vii',
    8: 'viii',
    9: 'ix',
    10: 'x',
    11: 'xi',
    12: 'xii',
    13: 'xiii',
    14: 'xiv',
    15: 'xv',
    16: 'xvi',
    17: 'xvii',
    18: 'xviii',
    19: 'xix',
    20: 'xx'
  }
  if (number <= 19 && number >= 0) return map[number + 1]
  else return ''
}

// 字符串长度处理
function strlen(str: string) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i)
    // 单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      len++
    } else {
      len += 3 // 汉字长度作为3处理，与python一致。
    }
  }
  return len
}

// 所有图片的宽度之和（优先取图片的width属性,并限制单图片宽度不超过50）
function getImgsWidth(html: string) {
  let imgsWidth = 0
  let div = document.createElement('div')
  div.innerHTML = html
  for (let img of div.getElementsByTagName('img')) {
    let width = (img.attributes as any).width
    if (!width) {
      imgsWidth += 50
    } else {
      let widthInt = Number.parseInt(width.value, 10) || 50
      if (widthInt > 50) {
        widthInt = 50
      }
      imgsWidth += widthInt
    }
  }
  return imgsWidth
}

// 选项长度等于字符串长度和所有图片宽度之和
function getOptionLength(option: string) {
  return strlen(html2Text(option || '')) + getImgsWidth(option) / 5
}

type OptionsLayout = 'option' | 'colx2' | 'colx3' | 'colx4' | 'option-inline'
// 选项布局方式 逐行(option)，2列，3列，4列，同行(option-inline)
function getOptionsLayout(options: string[]): OptionsLayout {
  let lens = options.map(getOptionLength)
  let count = lens.length || 0
  const maxLen = Math.max(...lens)
  if (count == 1) {
    return 'option-inline'
  } else if (count == 2) {
    if (maxLen <= 12 * 3) {
      return 'option-inline'
    } else {
      return 'option'
    }
  } else if (count == 3) {
    if (maxLen <= 8 * 3) {
      return 'option-inline'
    } else {
      return 'option'
    }
  } else if (count == 4) {
    if (maxLen <= 6 * 3) {
      return 'option-inline'
    } else if (6 * 3 < maxLen && maxLen <= 12 * 3) {
      return 'colx2'
    } else {
      return 'option'
    }
  } else {
    if (maxLen <= 18) {
      return 'colx4'
    } else if (6 * 3 < maxLen && maxLen <= 8 * 3) {
      return 'colx3'
    } else if (8 * 3 < maxLen && maxLen <= 12 * 3) {
      return 'colx2'
    } else {
      return 'option'
    }
  }
}

export {
  index2Abc,
  renderFormula,
  kpsDisplay,
  answersDisplay,
  transform,
  index2Roma,
  getOptionsLayout
}
